import React from "react";
import JourneyPlanner from "./JourneyPlanner";




const TravelPage = () => {
  return (
    <div>
      <h1>Travel Page</h1>
      <h2>Journey Planner: Addlestone to London Waterloo</h2>
      <JourneyPlanner from="Addlestone" to="London Waterloo" />
    </div>
  );
};

export default TravelPage;
